<template>
  <div class="container">
    <BaseFrame
    clearText=''
    submitText='保存'
    @submit='submit'
    @clear="cancel"
    >
      <div slot="content">
        <lk-form
          :model="customerInfo"
          :rules="customerInfoValidate"
          label-position="right"
          :label-width="130"
          ref="customerInfo"
        >
          <div class="cardContainer">
            <lk-card title="基本信息">
              <lk-row :gutter="16">
                <lk-col span="7" v-for="(item, index) in baseList" :key="index">
                  <lk-form-item :label="item.name">
                    <span>{{customerInfo[item.value] || ''}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="手机号" prop="mobile">
                    <lk-input v-model="customerInfo.mobile" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="公司名称" prop="companyName">
                    <lk-input v-model="customerInfo.companyName" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="收货信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="联系人：" prop="addressInfo.consigneeName">
                    <lk-input v-model="customerInfo.addressInfo.consigneeName" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="联系电话：" prop="addressInfo.consigneePhone">
                    <lk-input v-model="customerInfo.addressInfo.consigneePhone" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="地址：" prop="locationArr">
                    <Location v-model="customerInfo.locationArr" @on-change='handleLocation'></Location>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="详细地址：" prop="addressInfo.address">
                    <lk-input v-model="customerInfo.addressInfo.address" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="发票信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="公司名称：" prop="invoicesInfo.invoicesCompanyName">
                    <lk-input v-model="customerInfo.invoicesInfo.invoicesCompanyName" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="纳税人识别码：" prop="invoicesInfo.dutyParagraph">
                    <lk-input v-model="customerInfo.invoicesInfo.dutyParagraph" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="企业地址：" prop="invoicesInfo.companyAddress">
                    <lk-input v-model="customerInfo.invoicesInfo.companyAddress"  placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="企业电话：" prop="invoicesInfo.phone">
                    <lk-input v-model="customerInfo.invoicesInfo.phone" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="开户行：" prop="invoicesInfo.bank">
                    <lk-input v-model="customerInfo.invoicesInfo.bank" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="开户行银行卡号：" prop="invoicesInfo.bankAccount">
                    <lk-input v-model="customerInfo.invoicesInfo.bankAccount" placeholder="请输入"></lk-input>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="上传证件：" prop="picUrl">
                    <div v-for="(item, index) in imgList" :key="index" class="mb8">
                    <Uploader style="width:250px" :able='true' v-model="item.url"></Uploader>
                  </div>
                  <p v-if="imgList.length < 5" style="color: #1890FF" @click="addImgEvent">添加</p>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
  </div>
</template>

<script>
import Location from '@/components/location.vue';
import BaseFrame from '@/components/frame/BaseFrame.vue';
import service from '../../../services/lgq/services';
import utils from '../../../libs/utils';
import Uploader from '../../../components/Uploader.vue';
// import { util } from 'vue/types/umd';

export default {
  name: 'customerInfoEdit',
  components: {
    BaseFrame,
    Uploader,
    Location,
  },
  data() {
    return {
      customerInfo: {
        addressInfo: {},
        invoicesInfo: {},
        locationArr: [],
      },
      imgList: [],
      baseList: [
        { name: '账户id：', value: 'id' },
        { name: '创建时间：', value: 'createTime' },
        { name: '姓名：', value: 'name' },
      ],
      consigneeList: [
        { name: '联系人：', value: 'consigneeName' },
        { name: '联系电话：', value: 'consigneePhone' },
        { name: '公司名称：', value: 'companyName' },
        { name: '收货地址：', value: 'address' },
      ],
      billList: [
        { name: '公司名称：', value: 'companyName' },
        { name: '纳税人识别码：', value: 'dutyParagraph' },
        { name: '企业地址：', value: 'companyAddress' },
        { name: '企业电话：', value: 'phone' },
        { name: '开户行：', value: 'bank' },
        { name: '开户行银行卡号：', value: 'bankAccount' },
      ],
      customerInfoValidate: {
        mobile: [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        companyName: [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        'addressInfo.consigneeName': [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        'addressInfo.consigneePhone': [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: utils.validate.cellPhoneValidator, trigger: 'blur' },
        ],
        'addressInfo.address': [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        'invoicesInfo.invoicesCompanyName': [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        'invoicesInfo.dutyParagraph': [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        'invoicesInfo.companyAddress': [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        'invoicesInfo.phone': [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        'invoicesInfo.bank': [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        'invoicesInfo.bankAccount': [
          {
            required: true, message: '请输入', trigger: 'blur',
          },
        ],
        locationArr: [
          {
            required: true, message: '请选择地址', trigger: 'blur', type: 'array',
          },
        ],
      },
    };
  },
  computed: {
    createTime() {
      return utils.formatDateToSecond(this.customerInfo.createTime);
    },
  },
  methods: {
    addImgEvent() {
      this.imgList.push({ url: '' });
      const tempList = this.imgList;
      this.$set(this, 'imgList', tempList);
    },
    cancel() {
      this.$router.go(-1);
    },
    submit() {
      this.$refs.customerInfo.validate((msg) => {
        if (msg) {
          const params = this.configParams();
          service.updateCustomerInfo(params)
            .then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('保存成功');
                this.$router.go(-1);
              } else {
                this.$Message.error(res.data.error);
              }
            })
            .catch((err) => {
              utils.handleError(err);
            });
        }
      });
    },
    configParams() {
      const {
        id, name, mobile, companyName, addressInfo, invoicesInfo,
      } = utils.deepClone(this.customerInfo);
      if (invoicesInfo.invoicesCompanyName) {
        delete invoicesInfo.invoicesCompanyName;
      }
      const tempImgList = this.imgList.filter(item => item.url).map(item => (item.url));
      const params = {
        id,
        name,
        mobile,
        companyName,
        picUrls: tempImgList,
        customerAddresses: [{
          id: addressInfo.id,
          consigneeName: addressInfo.consigneeName,
          consigneePhone: addressInfo.consigneePhone,
          provinceId: addressInfo.provinceId,
          cityId: addressInfo.cityId,
          districtId: addressInfo.districtId,
          address: addressInfo.address,
        }],
        customerInvoices: [{
          id: invoicesInfo.id,
          companyName: invoicesInfo.companyName,
          dutyParagraph: invoicesInfo.dutyParagraph,
          companyAddress: invoicesInfo.companyAddress,
          phone: invoicesInfo.phone,
          bank: invoicesInfo.bank,
          bankAccount: invoicesInfo.bankAccount,
        }],
      };
      return params;
    },
    getInfo(id) {
      service.customerInfo({ customerId: id }).then((res) => {
        if (res.data.status === 200) {
          this.customerInfo = res.data.data;
          this.resetData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    resetData() {
      this.customerInfo.createTime = utils.formatDateToSecond(this.customerInfo.createTime);
      if (this.customerInfo.customerAddresses && this.customerInfo.customerAddresses.length > 0) {
        this.customerInfo.addressInfo = this.customerInfo.customerAddresses[0];
        const {
          provinceId, cityId, districtId, address,
        } = this.customerInfo.addressInfo;
        this.customerInfo.locationArr = [provinceId, cityId, districtId];
        this.customerInfo.addressInfo.address = address;
      } else {
        this.customerInfo.addressInfo = {};
      }
      if (this.customerInfo.customerInvoices && this.customerInfo.customerInvoices.length > 0) {
        this.customerInfo.invoicesInfo = this.customerInfo.customerInvoices[0];
        this.customerInfo.invoicesInfo.invoicesCompanyName = this.customerInfo.invoicesInfo.companyName;
      } else {
        this.customerInfo.invoicesInfo = {};
      }
      if (this.customerInfo.picUrls && this.customerInfo.picUrls.length > 0) {
        const tempList = this.customerInfo.picUrls.map(item => ({
          url: item,
        }));
        this.imgList = [];
        this.imgList.push(...tempList);
      }
    },
    handleLocation(val) {
      const [province, city, district] = val;
      this.customerInfo.addressInfo.provinceId = province;
      this.customerInfo.addressInfo.cityId = city;
      this.customerInfo.addressInfo.districtId = district;
    },
  },
  created() {
    this.getInfo(this.$route.params.id);
  },
};
</script>

<style scoped lang="less">
 .content {
    padding: 16px 0px 16px 0px;
    padding-bottom: 0px;
  }
</style>
